import { useMemo } from 'react';
import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';

export default function TrendPopupContentTrendGridSkeleton() {
  const Grid = useMemo(
    () =>
      Array.from({ length: 16 })?.map((_, colIdx) => (
        <div
          className={styles.container__column}
          key={`trend_grid_column_skeleton_${colIdx}`}
        >
          {Array.from({ length: 6 }).map((_, rowIndex) => (
            <div
              className={skeleton.cell}
              key={`trend_gridesp_cell_skeleton_${rowIndex}`}
            />
          ))}
        </div>
      )),
    [],
  );

  return <div className={styles.container}>{Grid}</div>;
}
